import {
  Typography,
  Card,
  Box,
  Divider,
  useMediaQuery,
  Theme,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useRecordContext, DateField } from "react-admin";
import AnimatedBlock from "../../../components/Common/AnimatedBlock";
import InfoRow from "../../../components/Common/InfoRow";
import { getName } from 'country-list';

// The create form offers "other" next to the ISO codes.
const countryName = (code?: string) => (!code ? "" : code === "other" ? "Other" : getName(code) || code);

// The customer the transaction was declared for (required from 1,000 €).
function InfoCustomerTab() {
  const { t }: { t: any } = useTranslation();
  const isMobile = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.down("sm")
  );
  const record = useRecordContext();
  const customer = record.customer;
  return (
    <Box>
      {!isMobile && (
        <Box pb={2}>
          <Typography variant="h6">
            {t("Customer")}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {t("The customer declared for this transaction.")}
          </Typography>
        </Box>
      )}

      <AnimatedBlock>
        <Card>
          <Box px={2} pt={2.5} pb={1.5}>
            <Typography variant="h5" fontWeight="bold">
              {customer.type === "company" ? t("Company") : t("Individual")}
            </Typography>
          </Box>
          <Divider />
          <Box px={2} py={1}>
            {customer.type === "individual" && (
              <>
                <InfoRow label={t("First name")}>{customer.firstname}</InfoRow>
                <InfoRow label={t("Last name")}>{customer.lastname}</InfoRow>
                <InfoRow label={t("Nationality")}>{countryName(customer.nationality)}</InfoRow>
                <InfoRow label={t("Birth date")}>
                  <DateField source="customer.birthDate" locales="fr-FR" sx={{ fontWeight: 700 }} />
                </InfoRow>
              </>
            )}
            {customer.type === "company" && (
              <>
                <InfoRow label={t("Legal name")}>{customer.companyName}</InfoRow>
                <InfoRow label={t("Address")}>{customer.companyAddress}</InfoRow>
                <InfoRow label={t("Country")}>{countryName(customer.companyCountry)}</InfoRow>
              </>
            )}
          </Box>
        </Card>
      </AnimatedBlock>
    </Box>
  );
}

export default InfoCustomerTab;
